export default "__VITE_ASSET__76knLQ3T__"